export default "__VITE_ASSET__fY8rLGHJ__"